"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCustomer = void 0;
const enums_1 = require("../../enums");
const validateCustomer = (customer) => {
    var _a;
    let missing = [];
    if (!customer)
        missing.push(enums_1.OrderValidation.MissingCustomer);
    if (!(customer === null || customer === void 0 ? void 0 : customer.reference))
        missing.push(enums_1.OrderValidation.MissingCustomerReference);
    if (!((_a = customer === null || customer === void 0 ? void 0 : customer.reference) === null || _a === void 0 ? void 0 : _a.bosApiId))
        missing.push(enums_1.OrderValidation.MissingCustomerReferenceBosApiId);
    if (!(customer === null || customer === void 0 ? void 0 : customer.bosCustomer))
        missing.push(enums_1.OrderValidation.MissingCustomerBosApiInstance);
    if (!(customer === null || customer === void 0 ? void 0 : customer.ssn))
        missing.push(enums_1.OrderValidation.MissingCustomerSocialNumber);
    return Array.from(new Set(missing));
};
exports.validateCustomer = validateCustomer;
//# sourceMappingURL=customer.js.map